// @flow
import React from "react";
import {
    RideAcceptedBottomContainer,
    RideAcceptedBottomInfoRow,
    RideAcceptedBottomTitleContainer,
    RideAcceptedCarIcon,
    RideAcceptedVanPlate,
    RideAcceptedVanInfo,
    RideAcceptedVanLabels,
    RideAcceptedVerticalDelimeter,
    RideAcceptedDriverImageContainer,
    RideAcceptedDriverPhoto,
    RideAcceptedCallDriver,
    RideAcceptedDriverName,
    RideAcceptedBottomTitle
} from "./RideAcceptedBottomStyle";
import { strings } from '../../../../../config';
import car_icon from '../../../../../Assets/commonImages/car_icon.svg';
import driver_icon_big from '../../../../../Assets/commonImages/driver_icon_big.svg';
import call_driver from '../../../../../Assets/commonImages/call_driver.svg';
import { RideAcceptedContentContainer } from "../RideAcceptedStyle";

type OwnProps = {|
    driverName: string,
    vehicleIdentifier: string,
    vehiclePlate: string,
    onCallDriver: () => void,
|}

const RideAcceptedBottom = (props: OwnProps) => {
    return (
        <RideAcceptedBottomContainer>
            <RideAcceptedBottomTitleContainer>
                <RideAcceptedBottomTitle>
                    {strings.bottom_proposal_box_title_text}
                </RideAcceptedBottomTitle>
            </RideAcceptedBottomTitleContainer>
            <RideAcceptedBottomInfoRow>
                <RideAcceptedContentContainer>
                    <RideAcceptedCarIcon src={car_icon} alt="car_icon"/>
                </RideAcceptedContentContainer>
                <RideAcceptedVanLabels>
                    <RideAcceptedVanPlate>
                        {strings.bottom_proposal_box_plate_prefix + props.vehiclePlate}
                    </RideAcceptedVanPlate>
                    <br/>
                    <RideAcceptedVanInfo>
                        {props.vehicleIdentifier}
                    </RideAcceptedVanInfo>
                </RideAcceptedVanLabels>
                <RideAcceptedContentContainer>
                    <RideAcceptedVerticalDelimeter/>
                </RideAcceptedContentContainer>
                <RideAcceptedContentContainer>
                    <RideAcceptedDriverImageContainer>
                        <RideAcceptedDriverPhoto src={driver_icon_big} alt="driver icon"/>
                        <RideAcceptedCallDriver src={call_driver} alt="call driver" onClick={props.onCallDriver}/>
                    </RideAcceptedDriverImageContainer>
                    <RideAcceptedDriverName>
                        {props.driverName}
                    </RideAcceptedDriverName>
                </RideAcceptedContentContainer>
            </RideAcceptedBottomInfoRow>
        </RideAcceptedBottomContainer>
    );
};

export default RideAcceptedBottom;



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAcceptedBottom/RideAcceptedBottom.js